import React, { useEffect, useState } from 'react';
import './Styles/AdminLoginPage.css';
import '../../constants/styleConstants.css';
import { useNavigate } from "react-router-dom";
import { LOCAL_STORAGE_KEYS } from '../../constants/Constants';
import sanctum_axios_client from '../../services/sanctum_axios_client';
import auth_axios_client from '../../services/auth_axios_client';
import LoadingSpinner from '../../Components/LoadingSpinner';
import { GeneralPopupComponent, PopupType } from '../../Components/GeneralPopupComponent';

const AdminLoginPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem(LOCAL_STORAGE_KEYS.isLoggedIn);
    const userType = localStorage.getItem(LOCAL_STORAGE_KEYS.userType);

    if (isLoggedIn === "true" && userType === "admin") {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [popup, setPopup] = useState<{
    open: boolean;
    type: PopupType;
    title: string;
    message: string;
    onClose?: () => void;
  }>({ open: false, type: "notice", title: "", message: "" });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sanctum_axios_client.get('/sanctum/csrf-cookie');
      const res = await auth_axios_client.post('/admin/login', { email, password });

      localStorage.setItem(LOCAL_STORAGE_KEYS.isLoggedIn, "true");
      localStorage.setItem(LOCAL_STORAGE_KEYS.userType, "admin");

      setPopup({
        open: true,
        type: "success",
        title: "Login Successful",
        message: res.data?.message || "Welcome!",
        onClose: () => {
          setPopup((p) => ({ ...p, open: false }));
          navigate("/admin/dashboard");
        },
      });
    } catch (e: any) {
      let msg = "Something went wrong. Try again.";
      if (e?.response?.data?.message) msg = e.response.data.message;
      setPopup({
        open: true,
        type: "error",
        title: "Login Failed",
        message: msg,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page">
      <div className="admin-login-card">
        <header className="admin-login-brand">
          <h1 className="admin-login-brand-title">Admin Portal</h1>
          <p className="admin-login-brand-subtitle">
            Sign in with your email and password
          </p>
        </header>

        <form className="admin-login-form" onSubmit={handleSubmit} noValidate>
          <div className="admin-login-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="admin-login-field">
            <label htmlFor="password">Password</label>
            <div className="admin-login-pin-group">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="admin-login-icon-button"
                onClick={() => setShowPassword((s) => !s)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                aria-pressed={showPassword}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <button className="admin-login-submit" type="submit" disabled={loading}>
            {loading ? <LoadingSpinner /> : "Sign in"}
          </button>

          <div className="admin-login-form-footer">
            <a href="#" onClick={(e) => e.preventDefault()}>
              Forgot Password?
            </a>
          </div>
        </form>
      </div>

      <GeneralPopupComponent
        isOpen={popup.open}
        onClose={popup.onClose || (() => setPopup((p) => ({ ...p, open: false })))}
        type={popup.type}
        title={popup.title}
        message={popup.message}
      />
    </main>
  );
};

export default AdminLoginPage;
